// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"483a71ae","74":"e163fc9e","141":"2b6b28eb","410":"fb234cdb","453":"c7120b5a","498":"8b705e6c","719":"3684dcf7"}[chunkId] + ".chunk.js";
};